<template>
  <div>
    <template v-if="isLoading">
      <Loading/>
    </template>
    <template v-else-if="hasDbError">
      <Error 
        v-for="(error,key) in dbErrors"
        v-if="error" 
        :key="key"
        error="error"/>
    </template>
    <template v-else>
      <template v-if="!isLoggedUser">
        <v-alert 
          :value="true"
          outline 
          class="mb-3"
          color="success" 
          v-html="$t('general.messages.createClub',{ email:$t('site.email') })" />
      </template>
      <v-layout 
        row 
        wrap>
        <v-flex
          v-for="(sport,key) in sportClubs"
          :key="key"
          class="xs12 md6">
          <v-card class="ma-1">
            <v-img 
              v-if="getSportLogo(key)"
              :src="getSportLogo(key)"
              class="sport-card"
              height="200px" 
              @click="goSport(key)">
              <v-container
                fill-height
                fluid
                pa-2 >
                <v-layout fill-height>
                  <v-flex 
                    xs12 
                    align-end 
                    flexbox>
                    <span class="headline white--text" >
                      {{ $t(`sport.types.${key}.name`) }}
                    </span>
                    <div 
                      v-if="false"
                      class="white--text" >
                      {{ $t('page.clubs.numClubs') }}: {{ sport.num }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
// import Vue from 'vue'
import _ from 'lodash'
import ClubsLib from '@/lib/data/clubs'
import Loading from '@/components/UIComponents/Loading/Loading'
import Error from '@/components/UIComponents/Error/Error'
import BaseMixin from '@/components/Dashboard/Mixin/BaseMixin'
import SportHelper from '@/lib/SportHelper'
import DateHelper from '@/lib/DateHelper'

import MetaHelper from '@/lib/MetaHelper'
import SecurityHelper from '@/lib/SecurityHelper'
import BaseTable from '@/components/Base/BaseTable'
import BaseTableTextArea from '@/components/Base/TableFields/BaseTableTextArea'
import ClubCard from '@/components/Dashboard/Views/Clubs/Templates/ClubCard'
import MatchesListContainer from '@/components/Dashboard/Views/Clubs/Templates/MatchesListContainer'
const debug = require('debug')('OD::Sports')

export default {
  name: 'Sports',
  components: { BaseTable, ClubCard, MatchesListContainer, BaseTableTextArea, Loading, Error },
  mixins: [BaseMixin],
  props: {
    yearId: {
      type: String,
      default: '',
    },
    weekId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      page: 'sports',
      entity: 'sport',
      sportIndex: null,
      clubs: [],
      sports: [],
      allSports: [
        'volleyball',
        'badminton',
        'indoor_soccer',
        'softball',
        'baseball',
        'basketball',
        'handball',
        'rugby',
        'soccer',
      ],
      loadings: {
        clubs: true,
      },
      dbErrors: {
        clubs: null,
      },
    }
  },
  computed: {
    isLoading() {
      return _.values(this.loadings).filter(loading => loading).length > 0
    },
    hasDbError() {
      return _.values(this.dbErrors).filter(error => error && error !== '').length > 0
    },
    isLoggedUser() {
      return SecurityHelper.isLoggedUser(this.currentUser)
    },
    sportClubs() {
      const clubs = this.clubs.slice(0)
      const sports = {}
      debug('clubs', clubs)
      clubs.forEach(item => {
        const sport = SportHelper.getSportConfiguration(item.sport).sport
        debug('itemn', item)
        if (!item.hide) {
          if (sports[sport]) {
            sports[sport].num += 1
          } else {
            sports[sport] = {
              num: 1,
            }
          }
        }
      })
      this.allSports.map(sport => {
        if (!sports[sport]) {
          sports[sport] = { num: 0 }
        }
      })
      return sports
    },
    week() {
      if (this.weekId) {
        return this.weekId
      }
      return `${DateHelper.getWeekNumber()}`
    },
    year() {
      if (this.yearId) {
        return this.yearId
      }
      return `${DateHelper.getYearNumber()}`
    },
  },
  watch: {
    currentUser() {
      this.bind()
    },
  },
  created() {},
  mounted() {
    this.bind()
  },
  beforeDestroy() {},
  firestore: {},
  methods: {
    bind() {
      ClubsLib.bindAll(this)
      this.sports = SportHelper.getClubSportList()
    },
    getSportLogo(sport) {
      debug('getSportLogo', sport)
      switch (sport) {
        case 'volleyball':
          return 'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/sports%2Fsport_voleyball.jpg?alt=media&token=08067f90-f188-480f-8ed3-2508dbd06851'
        case 'badminton':
          return 'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/sports%2Fsport_badminton.jpg?alt=media&token=da0bb91d-aab3-40eb-a7e8-88394f040e26'
        case 'softball':
          return 'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/sports%2Fsport_softball.jpg?alt=media&token=ae4afc51-92fd-4b35-89e1-2d0a34227308'
        case 'baseball':
          return 'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/sports%2Fsport_baseball.jpg?alt=media&token=1feac4c8-e219-4fa4-be00-b1aa1a50c259'
        case 'basketball':
          return 'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/sports%2Fsport_basketball.jpeg?alt=media&token=12668ec6-9423-4c0d-bd28-7b6e6e9d6f2d'
        case 'handball':
          return 'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/sports%2Fsport_handball.jpg?alt=media&token=a983214c-26e2-4d97-8a20-34b4f0782738'
        case 'rugby':
          return 'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/sports%2Fsport_rugby.jpg?alt=media&token=3cefd4f1-1569-445b-9df8-e7e80cc779fc'
        case 'soccer':
          return 'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/sports%2Fsport_football.jpg?alt=media&token=352f4e11-6dfa-4f18-9063-62328eb3f8b9'
        case 'indoor_soccer':
          return 'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/sports%2Fsport_futsal.jpg?alt=media&token=4e83a774-85e8-4f53-ab2e-c1bf97ef1d6a'
      }
      return ''
    },
    getSportName(item) {
      const sportId = item.sport || this.club.sport
      const sport = SportHelper.getSportConfiguration(sportId)
      return this.$t(`sport.types.${sport.sport}.name`)
    },
    onGo(item) {
      debug('onGo', item)
      this.navigateTo({ name: 'Club', params: { clubId: item.id } })
    },
    goSport(sport) {
      debug('goSport', sport)
      this.navigateTo({
        name: 'Clubs',
        params: {
          sport: sport,
          yearId: this.year,
          weekId: this.week,
        },
      })
    },
  },
  head: {
    title: function() {
      return MetaHelper.getTitle('clubs')
    },
    meta: function() {
      return MetaHelper.getMeta('clubs', { name: 'Sports' })
    },
  },
}
</script>

<style lang="scss">
.sport-card {
  .card__media__background {
    background-position: top center !important;
  }
}
</style>
